module.exports = __webpack_public_path__ + "static/img/case5-bg.19ef12c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homePage/case5-bg.jpg
// module id = dcLO
// module chunks = 0